/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 */

const LONG_LIFE_TRAFFIC_SOURCES = ['google_sem', 'trovit']

export const shouldUseLongLife = (params: URLSearchParams, token: string, value: string) => {
  const trafficParam = params.get('T')
  return (
    LONG_LIFE_TRAFFIC_SOURCES.includes(value) ||
    (token === 'C' && !!trafficParam && LONG_LIFE_TRAFFIC_SOURCES.includes(trafficParam))
  )
}
